import { colors } from '@mui/material';
import { styled } from '@mui/material/styles';

export const HeaderLeft = styled('div')({
  display: 'flex',
  alignItems: 'baseline',
  gap: 8,
  flexWrap: 'wrap',
});

export const CurrentPrice = styled('span')(({ theme }) => ({
  fontSize: '1.4rem',
  fontWeight: 700,
  color: theme.palette.text.primary,
  lineHeight: 1,
}));

export const ChangeLabel = styled('span', {
  shouldForwardProp: prop => prop !== 'positive',
})<{ positive: boolean }>(({ positive }) => ({
  fontSize: '0.82rem',
  fontWeight: 600,
  color: positive ? colors.green[700] : colors.red[700],
}));

export const PeriodControls = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  '& .MuiToggleButton-root': {
    fontSize: '0.72rem',
    padding: '2px 10px',
    textTransform: 'none',
    fontWeight: 600,
  },
  '& .MuiToggleButton-root.Mui-selected': {
    backgroundColor: '#1976d2',
    color: '#fff',
    '&:hover': { backgroundColor: '#1565c0' },
  },
});

export const Subtitle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.75),
  marginTop: theme.spacing(0.25),
  marginBottom: theme.spacing(1.5),
  fontSize: '0.75rem',
  color: theme.palette.text.secondary,
}));

export const StatBar = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'stretch',
  gap: 0,
  marginTop: theme.spacing(1.5),
  borderTop: `1px solid ${theme.palette.grey[200]}`,
  paddingTop: theme.spacing(1.5),
}));

export const StatItem = styled('div')(({ theme }) => ({
  flex: 1,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  borderRight: `1px solid ${theme.palette.grey[200]}`,
  '&:first-of-type': { paddingLeft: 0 },
  '&:last-of-type': { borderRight: 'none' },
}));

export const StatLabel = styled('div')(({ theme }) => ({
  fontSize: '0.68rem',
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  color: theme.palette.text.secondary,
  marginBottom: 2,
}));

export const StatValue = styled('div')(({ theme }) => ({
  fontSize: '0.9rem',
  fontWeight: 700,
  color: theme.palette.text.primary,
}));

export const RobustnessRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 6,
});

export const SeriesToggleRow = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(0.75),
  marginBottom: theme.spacing(1),
}));
